<template>
  <div>
    <v-card class="ma-1">
      <v-card-title>
        Select a periode
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col  cols="12" sm="5" md="3">
          <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="displayDate"
                  label="Periode"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="date"
                :type="pickerType"
                no-title
                scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                  text
                  color="primary"
                  @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>

          </v-col>

          <v-col  cols="12" sm="5" md="3">
          <v-select
              dense
              v-model="selectedPeriodType"
              :items="periodTypes"
              label="Jenis Periode"
              @change="handlePeriodTypeChange"
          ></v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions >
        <v-row justify="center">
          <v-col cols="auto">
            <v-btn @click="submit" :loading="isFetching">Submit</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>

    </v-card>

  <span v-show="isShowPage">
    <v-row align="center" justify="center">
      <v-col cols="3">
        <v-text-field
            append-icon="mdi-magnify"
            outlined
            solo
            hide-details
            v-model="search"
            class="search"
            placeholder="Search..."
            v-on:keyup.enter="getDataTable()"
            color="#2671D9"
        >
        </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn
                  class="ma-2"
                  depressed
                  outlined
                  color="#2671D9"
                  @click="exportExcel()"
              >
                <v-icon left color="#2671D9"> $ic-export-excel </v-icon>
                Export Excel
              </v-btn>
            </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <Table
            :headers="headers"
            :items="items"
            @onChangePage="getDataTable"
            @sortOptions="updateSortDatatable"
            :defaultSize="5"
            :loading="isFetching"
        >
          <template slot="Periode" slot-scope="{ item }">
            {{ formatDate(item.Periode) }}
          </template>

        </Table>
      </v-col>
    </v-row>
  </span>
  </div>
</template>
<script>
import Table from '../../components/Table.vue'
import HomeChargingServices from '@/services/default/HomeChargingServices'
import alert from '@/commons/helper/alert.helper'
import { StorageService } from '@/services/storage.service'

const homechargingServices = HomeChargingServices.build()
export default {
  name: 'monitoring-spklu-dc-v2',
  components: {
    Table
  },
  data: () => ({
    // date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    colorActive: '#2671D9',
    colorInactive: '#9A9A9A',
    headers: [
      {
        value: 'Periode',
        text: 'Periode',
        sortable: false,
        align: 'center',
        width: '50px'
      },
      {
        value: 'IDPEL',
        text: 'IDPEL',
        align: 'left',
        width: '170px'
      },
      {
        value: 'Pemilik HC',
        text: 'Pemilik HC',
        align: 'left',
        width: '180px'
      },
      {
        value: 'Alamat HC',
        text: 'Alamat HC',
        align: 'left',
        width: '120px'
      },
      {
        value: 'No Telpon',
        text: 'No Telp',
        align: 'left',
        width: '120px'
      },
      {
        value: 'Tanggal Integrasi',
        text: 'Tanggal Integrasi',
        align: 'center',
        width: '120px'
      },
      {
        value: 'Last Connected',
        text: 'Last Connected',
        align: 'left',
        width: '120px'
      },
      {
        value: 'Diskon kWh',
        text: 'Discount kWh',
        align: 'left',
        width: '120px'
      },
      {
        value: 'Regular kWh',
        text: 'Regular kWh',
        align: 'left',
        width: '120px'
      },
      {
        value: 'Status',
        text: 'status',
        align: 'left',
        width: '120px'
      },
      {
        value: 'Keterangan',
        text: 'Keterangan',
        align: 'left',
        width: '120px'
      },
      {
        value: 'Jenis_DPLD',
        text: 'Jenis DLPD',
        align: 'left',
        width: '120px'
      }
    ],
    items: {},
    search: '',
    sortSettings: '',
    isShowPage: false,
    isFetching: false,
    timer: '',
    date: new Date().toISOString().substr(0, 10),
    selectedPeriodType: 'HARIAN',
    periodTypes: ['HARIAN', 'BULANAN']
  }),
  async created () {
    // delete localStorage
    localStorage.removeItem('tableQuery')
  },

  computed: {

    pickerType () {
      return this.selectedPeriodType === 'HARIAN' ? 'date' : 'month'
    },

    displayDate () {
      if (this.selectedPeriodType === 'HARIAN') {
        return this.date ? this.date : ''
      } else {
        return this.date ? this.date.slice(0, 7) : ''
      }
    }
  },

  mounted: async function () {
    const responseAuth = await StorageService.getAuthdata()
    const branchName = responseAuth.branch.name.toLowerCase()

    if (this.isShowPage !== false) {
      let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
      localStorage.setItem(
        'tableQuery',
        JSON.stringify({
          page: tableQuery ? tableQuery.page : 0,
          size: tableQuery ? tableQuery.size : 20,
          sort_by: this.sortSettings
        })
      )

      tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
      await this.getDataTable(tableQuery.page, tableQuery.size)

      if (branchName === 'pusat') {
        this.search = ''
        await this.updateSortDatatable(tableQuery.sort_by)
        await this.getDataTable(tableQuery.page, tableQuery.size)
      } else {
        this.search = branchName
        await this.updateSortDatatable(tableQuery.sort_by)
        await this.getDataTable(tableQuery.page, tableQuery.size)
      }

      this.$nextTick(() => {
      // re-get data every 1 minute
        this.timer = setInterval(() => {
          const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
          if (tableQuery) {
            this.getDataTable(tableQuery.page, tableQuery.size)
          } else {
            this.getDataTable()
          }
        }, 60000)
      })
    }
  },

  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer)
  },
  watch: {
    search: function (val) {
      if (val === '') {
        this.getDataTable()
      }
    },

    date (newDate) {
      if (this.selectedPeriodType === 'HARIAN') {
        this.date = newDate
      } else {
        this.date = newDate.slice(0, 7)
      }
    }
  },

  methods: {
    openDialog () {
      this.dialog = true
    },
    async resetData () {
      this.items = {}
      // this.search = ''
      this.sortSettings = ''
    },

    formatDate (dateStr) {
      if (!dateStr) return ''
      const year = dateStr.slice(0, 4)
      const month = dateStr.slice(4, 6)
      const day = dateStr.slice(6, 8)
      if (day !== '') {
        return `${year}-${month}-${day}`
      } else {
        return `${year}-${month}`
      }
    },

    formattedDate () {
      if (this.selectedPeriodType === 'HARIAN') {
        return this.date ? this.date.replace(/-/g, '') : ''
      } else {
        return this.date ? this.date.slice(0, 7).replace(/-/g, '') : ''
      }
    },

    handlePeriodTypeChange () {
      this.date = new Date().toISOString().substr(0, this.selectedPeriodType === 'HARIAN' ? 10 : 7)
    },

    async getDataTable (page, size) {
      this.isFetching = true
      this.paging.page = page
      this.paging.size = size

      let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      localStorage.setItem(
        'tableQuery',
        JSON.stringify({
          page: page,
          size: size,
          sort_by: tableQuery ? tableQuery.sort_by : ''
        })
      )

      // re-get data after set
      tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      const param = Object.assign(
        {
          q: this.search,
          sort: tableQuery ? tableQuery.sort_by : '',
          jenisPeriode: this.selectedPeriodType,
          periode: this.formattedDate()
        },
        this.paging
      )

      const response = await homechargingServices.getDataDLPDHC(param)
      // console.log('response  >>>', response.data.data.content)
      if (response.data.success === true) {
        const {
          data: {
            data: {
              content,
              totalPages,
              number,
              size,
              totalElements
            }
          }
        } = response
        this.items = Object.assign({
          data: content,
          total: totalPages,
          size,
          page: number + 1,
          totalElements
        })
      } else {
        alert.failed(response.data.status + ' - ' + response.data.message)
      }
      this.isFetching = false
      this.isShowPage = true
    },

    async submit () {
      await this.getDataTable()
    },

    async updateSortDatatable (options) {
      if (options.sortBy) {
        this.sortSettings = ''
        for (let i = 0; i < options.sortBy.length; i++) {
          const sort = options.sortDesc[i] === false ? 'asc' : 'desc'
          let column = ''

          if (options.sortBy[i] === 'Periode') {
            column = 'Periode'
          } else if (options.sortBy[i] === 'IDPEL') {
            column = 'IDPEL'
          } else if (options.sortBy[i] === 'Pemilik HC') {
            column = 'Pemilik HC'
          } else if (options.sortBy[i] === 'Alamat HC') {
            column = 'Alamat HC'
          } else if (options.sortBy[i] === 'No Telpon') {
            column = 'No Telpon'
          } else if (options.sortBy[i] === 'Tanggal Integrasi') {
            column = 'Tanggal Integrasi'
          } else if (options.sortBy[i] === 'Last Connected') {
            column = 'Last Connected'
          } else if (options.sortBy[i] === 'Diskon kWh') {
            column = 'Diskon kWh'
          } else if (options.sortBy[i] === 'Regular kWh') {
            column = 'Regular kWh'
          } else if (options.sortBy[i] === 'Status') {
            column = 'Status'
          } else if (options.sortBy[i] === 'Keterangan') {
            column = 'Keterangan'
          } else if (options.sortBy[i] === 'Jenis_DPLD') {
            column = 'Jenis_DPLD'
          }

          if (i === 0) {
            this.sortSettings += column + ',' + sort
          } else {
            this.sortSettings += '&sort=' + column + ',' + sort
          }
        }

        let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        localStorage.setItem(
          'tableQuery',
          JSON.stringify({
            page: tableQuery ? tableQuery.page : 0,
            size: tableQuery ? tableQuery.size : 20,
            sort_by: this.sortSettings
          })
        )
        tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        if (this.isShowPage !== false) {
          await this.getDataTable(tableQuery.page, tableQuery.size)
        }
      }
    },

    async exportExcel (page, size) {
      this.paging.page = page
      this.paging.size = size
      let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      localStorage.setItem(
        'tableQuery',
        JSON.stringify({
          page: page,
          size: size,
          sort_by: tableQuery ? tableQuery.sort_by : ''
        })
      )

      // re-get data after set
      tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      const param = Object.assign(
        {
          q: this.search,
          sort: tableQuery ? tableQuery.sort_by : '',
          jenisPeriode: this.selectedPeriodType,
          periode: this.formattedDate(),
          name: 'Data-DLPD' + this.formattedDate() + '.xlsx'
        },
        this.paging
      )
      await homechargingServices.exportDataDLPD(param)
    }
  }
}
</script>
<style scoped>
.search {
  height: 48px;
}
</style>
